 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLE from '@/components/title'
 import COPYRIGHT from '@/components/copyright'
 import DED from '@/components/ded'
 import CONTENTS from '@/components/contents'
 import PREFACE from '@/components/preface'
 import ACK from '@/components/ack'
 import INTRO from '@/components/intro'
 import CHAPTER1 from '@/components/chapter1'
 import CHAPTER2 from '@/components/chapter2'
 import CHAPTER3 from '@/components/chapter3'
 import CHAPTER4 from '@/components/chapter4'
 import CHAPTER5 from '@/components/chapter5'
 import CHAPTER6 from '@/components/chapter6'
 import CHAPTER7 from '@/components/chapter7'
 import CONCLUSION from '@/components/conclusion'
 import NOTES from '@/components/notes'
 import AUTHOR from '@/components/author'
 import END from '@/components/end'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/preface",
 			"name" : "preface",
 			"component" : PREFACE
 		},
 		{
 			"path" : "/ack",
 			"name" : "ack",
 			"component" : ACK
 		},
 		{
 			"path" : "/intro",
 			"name" : "intro",
 			"component" : INTRO
 		},
 		{
 			"path" : "/chapter1",
 			"name" : "chapter1",
 			"component" : CHAPTER1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js